import { useThemeColors } from '../../theme';

/**
 * Maps a 0–100 pronunciation score to a semantic theme color.
 * ≥80 → success, 60–79 → warning, <60 → error.
 *
 * Shared by {@link FeedbackCard}'s pronunciation section and
 * {@link PronunciationBreakdown} so word- and phoneme-level scoring colors stay
 * consistent across the chat pronunciation UI. Returns an actual color value for
 * use in `style` props (not a Gluestack `$token`).
 */
export function getScoreStyleColor(
  score: number,
  theme: ReturnType<typeof useThemeColors>,
): string {
  if (score >= 80) return theme.success;
  if (score >= 60) return theme.warning;
  return theme.error;
}
